var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainView"},[_c('headerView',{staticClass:"header",attrs:{"currentMenu":"book"}}),_c('div',{staticClass:"header-bg-div"}),_c('div',{staticClass:"content"},[_c('contentDetail',{ref:"contentDetail"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }